import { FC } from 'react';
import { ChevronSvg } from '@/features/pages/profile/wlas-widget/components/WlasTabsPanel/tabs/configuration/styled';

export const WlasChevronIcon: FC<{ open: boolean }> = ({ open }) => (
  <ChevronSvg $open={open} width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M3 5L7 9L11 5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ChevronSvg>
);
